const source = 'fattureClientiDataTable'

function doFunction () {
  const keys = Object.keys(this.filtered.items).filter((s) => s == source)

  if(keys.length > 0){

    const items = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'fatture-vendita-quietanza',
      title: 'Crea Quietanza',
      data: items,
      maximize: false,
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': doFunction,
}
